import React from 'react';

import paymentPageStyles from './paymentPage.module.css';
import { formatCurrency } from '../../utils/currencyFormatter';

interface paymentDetailsProps {
  due: string;
  items: number;
  totalPay: number;
  disabled: boolean;
  totalConvenience: string;
  textConvenienceFee: string;
  stripeTax?: string;
  applyEwallet?: boolean;
  eWalletAmount?: string;
};

const paymentDetails = (props: paymentDetailsProps) => {

  return (

    <div className={ [paymentPageStyles.invoiceWrapper, props.disabled? paymentPageStyles.disabledLabelColor : '' ].join(' ') }>

      <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={ paymentPageStyles.itemText }>Current amount due:</div>

        <div className={ paymentPageStyles.invoicePrice }>

          <div>$</div> 
          <div>{ props.due }</div>

        </div>

      </div>

      <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={ paymentPageStyles.itemText} >{ props.textConvenienceFee }</div> 

        <div className={ [paymentPageStyles.invoicePrice].join(' ') }>

          <div>$</div> 
          <div>{ props.totalConvenience }</div>

        </div>

      </div>
      { props.stripeTax && <div className={ paymentPageStyles.invoiceItemsWrapper }>

      <div className={ paymentPageStyles.itemText} >CC charge fee</div> 

        <div className={ [paymentPageStyles.invoicePrice, props.applyEwallet ? '' : paymentPageStyles.border].join(' ') }>

          <div>$</div> 
          <div>{ props.stripeTax }</div>

        </div>

      </div> }
      { props.applyEwallet && <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={ paymentPageStyles.itemText} >e wallet balance</div> 

          <div className={ [paymentPageStyles.invoicePrice, paymentPageStyles.border].join(' ') }>

            <div>-$</div> 
            <div>{ props.eWalletAmount }</div>

          </div>

        </div> 
      }

      <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={ paymentPageStyles.itemText } />

        <div className={ paymentPageStyles.invoicePrice }>

          <div>$</div> 
          <div>{ props.applyEwallet ? formatCurrency((props.totalPay - Number(props.eWalletAmount)), 2) : formatCurrency(props.totalPay, 2) }</div>

        </div>

      </div>

    </div>
  );
};

export default paymentDetails;
